"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var BaseTransform_1 = require("./BaseTransform");

var ConditionalHelper_1 = require("../../helpers/ConditionalHelper");

var VisibleTransform =
/** @class */
function (_super) {
  __extends(VisibleTransform, _super);

  function VisibleTransform() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  VisibleTransform.prototype.execute = function (queryResponse, queryOptions, executionOptions) {
    var visibleOptions = this.options.visibleOptions;
    var response = queryResponse;

    if (visibleOptions) {
      var mode = visibleOptions.mode,
          conditional = visibleOptions.conditional,
          hideValue = visibleOptions.hideValue;
      var conditionalHelper = new ConditionalHelper_1.ConditionalHelper(conditional, this.translationHelper);
      var conditionMatches = conditionalHelper.matchesWithOptions({
        executionOptions: executionOptions,
        instance: queryResponse
      });
      var hide = mode === 'hide';
      var show = mode === 'show';

      if (hide && conditionMatches || show && !conditionMatches) {
        response = hideValue;
      }
    }

    return response;
  };

  return VisibleTransform;
}(BaseTransform_1.BaseTransform);

exports.VisibleTransform = VisibleTransform;